import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from "framer-motion";
import CircularProgress from '@mui/material/CircularProgress';
import imgNetworkError from '../../images/common/network_error.png';
import refresh from '../../images/common/refresh.png';

const ErrorBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  text-align: center;
`;

const ImgBox = styled.div`
  width: 14rem;
  height: 14rem;
  & img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const Title = styled.strong`
  padding-top: var(--sp-10);
  font-size: var(--mo-fz-md);
  color: var(--color-main-gray);
  font-weight: var(--fz-weight-700);
`;

const RefreshButton = styled.button`
  margin-top: var(--sp-12);
  display: flex;
  align-items: center;
  gap: 8px;
  
  & img {
    width: 20px;
    height: 20px;
  }
`;

const LoadingDialog = styled.div`
  display: flex; 
  align-items: center; 
  justify-content: center; 
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  padding: 0 var(--sp-16);
  background-color: rgba(0,0,0,0.7);
  
  & .in-layout {
    display: flex; 
    align-items: center; 
    justify-content: center; 
    width: 100%;
    max-width: 30rem;
    height: auto;
    border-radius: var(--radius-20);
    background-color: var(--color-white);
    outline: none;
  }
`;

const NetworkErrorBox = () => {
  const [isLoadingModalOpen, setIsLoadingModalOpen] = useState(false);

  const handleRefresh = () => {
    setIsLoadingModalOpen(true);

    setTimeout(() => {
      if (navigator.onLine) {
        window.location.reload();
      } else {
        setIsLoadingModalOpen(false);
        alert('네트워크 연결을 확인해주세요.');
      }
    }, 2500);
  };

  return (
    <>
      <AnimatePresence>
        {isLoadingModalOpen && (
          <LoadingDialog role="dialog" aria-modal="true">
            <motion.div
              className="in-layout"
              tabIndex={-1}
              onClick={(e) => e.stopPropagation()}
              initial={{ opacity: 0, scale: 0.75 }}
              animate={{ opacity: 1, scale: 1, transition: { ease: "easeOut", duration: 0.15 } }}
              exit={{ opacity: 0, scale: 0.75, transition: { ease: "easeIn", duration: 0.15 } }}
            >
              <div className={'modal-box'} data-pad="normal">
                <div className='modal-top-box'>
                  <div className='title-box'>
                    <p>환자 정보 조회중... </p>
                  </div>
                  <CircularProgress size="3.2rem" className='m-t-20' />
                </div>
              </div>
            </motion.div>
          </LoadingDialog>
        )}
      </AnimatePresence>

      <ErrorBox>
        <ImgBox>
          <img src={imgNetworkError} alt="네트워크 에러" />
        </ImgBox>
        <Title>앗, 화면을 불러오지 못했어요!</Title>
        <RefreshButton className='btn' data-btn-type="fill-main" data-btn-size="smd" onClick={handleRefresh}>
          <span>새로고침</span>
          <img src={refresh} alt="" />
        </RefreshButton>
      </ErrorBox>
    </>
  );
};

export default NetworkErrorBox;